import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import "./CosmicBackground.css";

/**
 * Decorative, fixed full-viewport cosmic backdrop for the landing page.
 * Purely visual (aria-hidden, pointer-events: none) so it never affects
 * SEO content or any interaction. Three star layers parallax on scroll via
 * framer-motion motion values (no re-renders), with slow-drifting nebula and
 * floating glow orbs. Honors prefers-reduced-motion.
 */
export default function CosmicBackground() {
  const prefersReduced = useReducedMotion();
  const { scrollYProgress } = useScroll();

  const yFar = useTransform(scrollYProgress, [0, 1], [0, -30]);
  const yMid = useTransform(scrollYProgress, [0, 1], [0, -80]);
  const yNear = useTransform(scrollYProgress, [0, 1], [0, -140]);

  return (
    <div className="cosmic-bg" aria-hidden="true">
      <div className="cosmic-nebula" />

      <motion.div
        className="cosmic-stars cosmic-stars--far"
        style={prefersReduced ? undefined : { y: yFar }}
      />
      <motion.div
        className="cosmic-stars cosmic-stars--mid"
        style={prefersReduced ? undefined : { y: yMid }}
      />
      <motion.div
        className="cosmic-stars cosmic-stars--near"
        style={prefersReduced ? undefined : { y: yNear }}
      />

      <div className="cosmic-orb cosmic-orb--1" />
      <div className="cosmic-orb cosmic-orb--2" />
    </div>
  );
}
